<template>
    <div class="personalities-main-publications">
        <div class="d-flex">
            <div class="personalities-title text-left">
                Основные публикации
            </div>
            <div class="ml-auto mt-2">
                <svg-icon
                @click="svgClick"
                :svgData="svgData"/>
            </div>
        </div>
        <div v-if="this.open">
            <div v-for="(file, key) in this.main_publications" :key="key">
                <personalities-file :href="file.href" :text="file.text" class="mt-5"/>
            </div>
        </div>
        <div class="personalities-border mt-6"></div>
    </div>
    <div class="personalities-edit" v-if="can_edit_personality">
      <v-container class="ma-0 pa-0 mt-10" fluid>
        <v-row v-for="(file, key) in main_publications" :key="key">
            <v-col cols=5>
                <v-text-field
                    class="mr-4"
                    label="Ссылка"
                    :model-value="getMainPublicationItemHref(key)"
                    @update:model-value="newValue => setMainPublicationItemHref(key, newValue)">
                </v-text-field>
            </v-col>
            <v-col cols=5>
                <v-text-field
                    class="mr-4"
                    label="Текст ссылки"
                    :model-value="getMainPublicationItemText(key)"
                    @update:model-value="newValue => setMainPublicationItemText(key, newValue)">
                </v-text-field>
            </v-col>
            <v-col cols =2>
                <v-btn
                @click="delItem(key)"
                >
                Удалить
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols=12>
                <v-btn @click="addItem">
                    Добавить
                </v-btn>
            </v-col>
        </v-row>
      </v-container>
    </div>
</template>
<script>

import PersonalitiesFile from '@/components/personalities/PersonalitiesFile.vue'
import SvgIcon from '@/components/content/SvgIcon.vue'
import { useUserStore } from '@/store/user';
import { useAuthStore } from '@/store/auth';

export default{
    name: 'PersonalitiesScienceAchievements',
    components: {
        SvgIcon,
        PersonalitiesFile
    },
    data () {
            return {
                open: true,
                svgData: {
                    width: "24",
                    height: "24",
                    viewBox: "0 0 24 24",
                    pathArr: [{
                        d: "M23.6673 13.6668H13.6673V23.6668H10.334V13.6668H0.333984V10.3335H10.334V0.333496H13.6673V10.3335H23.6673V13.6668Z",
                        fill: "#3B66D3"}]},
                main_publicationnn: [{'href': 'http://google.com', 'text': 'Ссылка 1'},
                    {'href': 'http://google.com', 'text': 'Ссылка 2'}]
      }
    },
    computed:{
        main_publications:{
            get(){
                const userStore = useUserStore()
                if (userStore.changeUser.main_publications)
                    return userStore.changeUser.main_publications
                return []
            }
        },
        can_edit_personality() {
            let AuthStore = useAuthStore()
            return AuthStore.can_edit_personality
        }
        
    },
    methods: {
        svgClick() {
            this.open=!this.open
        },
        getMainPublicationItemHref(index){
            return this.main_publications[index].href
        },
        getMainPublicationItemText(index){
            return this.main_publications[index].text
        },
        setMainPublicationItemHref(index, newValue){
            this.main_publications[index].href = newValue
        },
        setMainPublicationItemText(index, newValue){
            this.main_publications[index].text = newValue
        },
        addItem(){
            const userStore = useUserStore()
            if (!userStore.changeUser.main_publications){
                userStore.changeUser.main_publications = []
            }
            userStore.changeUser.main_publications.push({"href":"",
            "text":""})
        },
        delItem(i){
            const userStore = useUserStore()
            userStore.changeUser.main_publications.splice(i,1)
        }
    }
}
</script>